import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const pdsProgressCss = ":host{--color-progress-fill:var(--pine-color-brand);--sizing-progress-bar-width:100%;-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;width:var(--sizing-progress-bar-width)}@-webkit-keyframes progressBar{0%{width:0}100%{width:var(--sizing-progress-bar-width)}}@keyframes progressBar{0%{width:0}100%{width:var(--sizing-progress-bar-width)}}.pds-progress{-ms-flex-align:center;align-items:center;background-color:var(--pine-color-background-container-disabled);border-radius:var(--pine-dimension-2xs);display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;height:var(--pine-dimension-xs);position:relative;width:100%}:host(.is-animated) progress,:host(.is-animated) progress::-webkit-progress-bar{-webkit-animation:progressBar 3s ease;animation:progressBar 3s ease;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}progress,progress::-webkit-progress-bar{background-color:transparent;border:0;height:var(--pine-dimension-xs);width:100%}progress::-webkit-progress-value{background-color:var(--color-progress-fill, var(--pine-color-brand));border-radius:var(--pine-dimension-2xs)}progress::-moz-progress-bar{background-color:var(--color-progress-fill, var(--pine-color-brand));border-radius:var(--pine-dimension-2xs)}.pds-progress__label{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.pds-progress__percentage{font-weight:var(--pine-font-weight-medium);-webkit-margin-start:calc(var(--pine-dimension-md) / 2);margin-inline-start:calc(var(--pine-dimension-md) / 2)}";
const PdsProgressStyle0 = pdsProgressCss;

const PdsProgress$1 = /*@__PURE__*/ proxyCustomElement(class PdsProgress extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.animated = false;
        this.componentId = undefined;
        this.fillColor = undefined;
        this.label = undefined;
        this.percent = 0;
        this.showPercent = false;
    }
    render() {
        return (h(Host, { key: 'd1035166aecc2b1719f827e51bcab880f0f6c77c', class: this.animated ? { 'is-animated': this.animated } : '' }, h("div", { key: '52385ffd15e98e43ebbbf89397950fcf44d0fa08', class: "pds-progress" }, h("label", { key: '56d3b58ed6cb0531a874cd8033770dbe4741f992', class: "pds-progress__label", htmlFor: this.componentId }, this.label), h("progress", { key: 'c98a6707f1d30f8e4c05dd53c0fc2fbe6a3f6284', id: this.componentId, max: "100", style: this.fillColor ? { '--color-progress-fill': this.fillColor } : {}, value: this.percent })), this.showPercent && h("div", { key: '621c6fd0a5fc275358c583513ba463d9c01dee32', class: "pds-progress__percentage" }, this.percent, "%")));
    }
    static get style() { return PdsProgressStyle0; }
}, [1, "pds-progress", {
        "animated": [4],
        "componentId": [1, "component-id"],
        "fillColor": [1, "fill-color"],
        "label": [1],
        "percent": [2],
        "showPercent": [4, "show-percent"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-progress"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-progress":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsProgress$1);
            }
            break;
    } });
}

const PdsProgress = PdsProgress$1;
const defineCustomElement = defineCustomElement$1;

export { PdsProgress, defineCustomElement };

//# sourceMappingURL=pds-progress.js.map